export default __webpack_public_path__ + "static/media/fitnessLogo.93950585.PNG";